"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var Checkbox_1 = require("../Checkbox");
var Form_1 = require("../Form");
var Icon_1 = require("../Icon");
var Paper_1 = require("../Paper");
var Switch_1 = require("../Switch");
var TextField_1 = require("../TextField");
var Typography_1 = require("../Typography");
var TableColumnSettingsStyles_1 = require("./TableColumnSettingsStyles");
var reorder = function (list, startIndex, endIndex) {
    var result = Array.from(list);
    var removed = result.splice(startIndex, 1)[0];
    result.splice(endIndex, 0, removed);
    return result;
};
var DEFAULT_LOCALES = {
    searchPlaceholder: 'Search',
    showAllSwitchLabel: 'Show all',
    columnShowCheckboxLabel: 'show'
};
var useLocales = function (locales) {
    return react_1.useMemo(function () {
        if (!locales) {
            return DEFAULT_LOCALES;
        }
        return tslib_1.__assign(tslib_1.__assign({}, DEFAULT_LOCALES), locales);
    }, [locales]);
};
var TableColumnSettings = function (_a) {
    var columns = _a.columns, onColumnsChange = _a.onColumnsChange, _b = _a.locales, propLocales = _b === void 0 ? {} : _b;
    var classes = TableColumnSettingsStyles_1.useClasses();
    var _c = react_1.useState(''), searchQuery = _c[0], setSearchQuery = _c[1];
    var locales = useLocales(propLocales);
    var checkedColumnsCount = react_1.useMemo(function () { return columns.filter(function (column) { return column.show; }).length; }, [columns]);
    var showAll = checkedColumnsCount === columns.length;
    var filteredColumns = columns;
    if (searchQuery) {
        filteredColumns = columns.filter(function (column) {
            return column.label.toLowerCase().includes(searchQuery.toLowerCase());
        });
    }
    react_1.useEffect(function () {
        if (checkedColumnsCount === 0) {
            var _a = tslib_1.__spreadArrays(columns), firstColumn = _a[0], restColumns = _a.slice(1);
            onColumnsChange === null || onColumnsChange === void 0 ? void 0 : onColumnsChange(tslib_1.__spreadArrays([tslib_1.__assign(tslib_1.__assign({}, firstColumn), { show: true })], restColumns));
        }
    }, [columns, onColumnsChange, checkedColumnsCount]);
    var onTextFieldChange = function (event) {
        setSearchQuery(event.target.value);
    };
    var onShowAll = function () {
        if (showAll) {
            var _a = tslib_1.__spreadArrays(columns), firstColumn = _a[0], restColumns = _a.slice(1);
            var restColumnsHidden = restColumns.map(function (column) { return (tslib_1.__assign(tslib_1.__assign({}, column), { show: false })); });
            onColumnsChange === null || onColumnsChange === void 0 ? void 0 : onColumnsChange(tslib_1.__spreadArrays([firstColumn], restColumnsHidden));
            return;
        }
        var columnsAllShow = columns.map(function (column) { return (tslib_1.__assign(tslib_1.__assign({}, column), { show: true })); });
        onColumnsChange === null || onColumnsChange === void 0 ? void 0 : onColumnsChange(columnsAllShow);
    };
    var onToggleColumn = function (columnClicked) { return function () {
        var updatedColumns = columns.map(function (column) {
            if (column.label === columnClicked.label) {
                return tslib_1.__assign(tslib_1.__assign({}, column), { show: !column.show });
            }
            return column;
        });
        onColumnsChange === null || onColumnsChange === void 0 ? void 0 : onColumnsChange(updatedColumns);
    }; };
    var onDragEnd = function (result) {
        if (!result.destination) {
            return;
        }
        var updatedColumns = reorder(columns, result.source.index, result.destination.index);
        onColumnsChange === null || onColumnsChange === void 0 ? void 0 : onColumnsChange(updatedColumns);
    };
    return (react_1["default"].createElement("div", { className: classes.container },
        react_1["default"].createElement("div", { className: classes.header },
            react_1["default"].createElement(TextField_1.TextField, { InputProps: {
                    endAdornment: (react_1["default"].createElement(Form_1.InputAdornment, { position: "end" },
                        react_1["default"].createElement(Icon_1.Icon, { color: "secondary", name: "search" }))),
                    classes: { root: classes.inputRoot }
                }, fullWidth: true, label: "Label", onChange: onTextFieldChange, placeholder: locales.searchPlaceholder, value: searchQuery, variant: "outlined" })),
        react_1["default"].createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDragEnd },
            react_1["default"].createElement(react_beautiful_dnd_1.Droppable, { droppableId: "table-settings-droppable" }, function (provided) { return (react_1["default"].createElement("div", tslib_1.__assign({}, provided.droppableProps, { className: classes.contentContainer, ref: provided.innerRef }),
                react_1["default"].createElement(Form_1.FormControlLabel, { classes: {
                        root: classes.formControlRoot,
                        label: classes.formControlLabel
                    }, control: react_1["default"].createElement(Switch_1.Switch, { checked: showAll, classes: { track: classes.switchTrack }, onChange: onShowAll, size: "small" }), label: locales.showAllSwitchLabel }),
                filteredColumns.map(function (column, index) { return (react_1["default"].createElement(ColumnItem, { checkedColumnsCount: checkedColumnsCount, column: column, draggable: !searchQuery, index: index, key: column.label + "-" + index, locales: locales, onToggleColumn: onToggleColumn(column) })); }),
                provided.placeholder)); }))));
};
var ColumnItem = function (_a) {
    var _b;
    var column = _a.column, index = _a.index, checkedColumnsCount = _a.checkedColumnsCount, onToggleColumn = _a.onToggleColumn, _c = _a.draggable, draggable = _c === void 0 ? true : _c, locales = _a.locales;
    var classes = TableColumnSettingsStyles_1.useClasses();
    if (!draggable) {
        return (react_1["default"].createElement(Paper_1.Paper, { className: classes.item },
            react_1["default"].createElement("div", { className: classes.informationContainer },
                react_1["default"].createElement(Icon_1.Icon, { className: classes.dragIcon + " " + classes.dragIconDisabled, color: "secondary", name: "drag_indicator" }),
                react_1["default"].createElement(Typography_1.BodyText, { className: classes.text }, column.label)),
            react_1["default"].createElement("div", { "aria-hidden": "true", className: classnames_1["default"]((_b = {},
                    _b[classes.showContainer] = true,
                    _b[classes.noClick] = checkedColumnsCount === 1 && column.show,
                    _b)), onClick: onToggleColumn },
                react_1["default"].createElement(Checkbox_1.Checkbox, { checked: column.show, color: "primary", disabled: checkedColumnsCount === 1 && column.show, size: "small" }),
                react_1["default"].createElement(Typography_1.BodyText, null, "Show"))));
    }
    return (react_1["default"].createElement(react_beautiful_dnd_1.Draggable, { draggableId: column.label + "-" + index, index: index, key: column.label + "-" + index }, function (provided, snapshot) {
        var _a, _b;
        return (react_1["default"].createElement(Paper_1.Paper, tslib_1.__assign({ className: classnames_1["default"]((_a = {},
                _a[classes.item] = true,
                _a[classes.dragItem] = snapshot.isDragging,
                _a)), ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: provided.draggableProps.style }),
            react_1["default"].createElement("div", { className: classes.informationContainer },
                react_1["default"].createElement(Icon_1.Icon, { className: classes.dragIcon, color: "secondary", name: "drag_indicator" }),
                react_1["default"].createElement(Typography_1.BodyText, { className: classes.text }, column.label)),
            react_1["default"].createElement("div", { "aria-hidden": "true", className: classnames_1["default"]((_b = {},
                    _b[classes.showContainer] = true,
                    _b[classes.noClick] = checkedColumnsCount === 1 && column.show,
                    _b)), onClick: onToggleColumn },
                react_1["default"].createElement(Checkbox_1.Checkbox, { checked: column.show, color: "primary", disabled: checkedColumnsCount === 1 && column.show, size: "small" }),
                react_1["default"].createElement(Typography_1.BodyText, null, locales.columnShowCheckboxLabel))));
    }));
};
exports["default"] = TableColumnSettings;
//# sourceMappingURL=TableColumnSettings.js.map